import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

type CustomerPortalResponse = {
  url: string;
};

export type Address = {
  city?: string;
  country?: string;
  line1?: string;
  line2?: string;
  postalCode?: string;
  state?: string;
};

@Injectable()
export class SubscriptionService {
  constructor(private readonly HttpClient: HttpClient) {}

  async getCustomerPortalUrl() {
    const { url } = await this.HttpClient.get<CustomerPortalResponse>(
      environment.managirUrl + "/stripe/customer-portal"
    ).toPromise();

    return url;
  }

  getAddress() {
    return this.HttpClient.get<Address>(
      environment.managirUrl + "/stripe/address"
    ).toPromise();
  }

  updateAddress(address: Address) {
    return this.HttpClient.put<Address>(
      environment.managirUrl + "/stripe/address",
      { address }
    ).toPromise();
  }
}



// WEBPACK FOOTER //
// /agir/src/app/services/subscription/subscription.service.ts